import { SearchOutlined } from '@ant-design/icons';
import { Button, ButtonProps } from 'antd';
import * as React from 'react';

interface SearchButtonState { }

interface SearchButtonProps extends ButtonProps {
  searching?: boolean;
}

class SearchButton extends React.Component<SearchButtonProps, SearchButtonState> {
  constructor(props: SearchButtonProps) {
    super(props);

    this.state = {};
  }

  render() {
    const htmlType = this.props.htmlType ? this.props.htmlType : 'submit'
    const buttonType = this.props.type ? this.props.type : 'primary'

    return (
      <Button
        {...this.props}
        htmlType={htmlType}
        type={buttonType}
        icon={<SearchOutlined />}
        loading={this.props.searching} >
        Search
      </Button>
    );
  }
}

export default SearchButton;
